import { Link } from "react-router-dom";
import { Box, Typography } from "@mui/material";

function ProcessingPage() {
  return (
    <Box className="my-10 mx-auto px-4 max-w-5xl">
      <Typography variant="h4" component="h1" className="mb-4">
        Processing — Shared for All Stone Types
      </Typography>
      <Typography variant="body1" className="mb-4">
        This finishes list is shared for granite, marble, sandstone, and
        limestone, and is listed once here — it is not repeated on every
        stone page. We process to meet clients&apos; finish requirements.
      </Typography>
      <ul className="list-disc ml-6 space-y-1 mb-6">
        <li>Polished</li>
        <li>Honed</li>
        <li>Fine Picked (= Bush Hammered)</li>
        <li>Rough Picked</li>
        <li>Split</li>
        <li>Tumbled</li>
        <li>Flamed</li>
        <li>Flamed + Brushed</li>
        <li>Sandblasted</li>
        <li>Pineapple</li>
        <li>Chiseled</li>
        <li>Acid Washed</li>
      </ul>
      <Typography variant="body1" className="mb-4">
        Stone is cut to size to your design requirements.
      </Typography>
      <Typography variant="body1" className="mb-4">
        If you need a finish not listed here, send us a photo and we will
        have the factory process it to match.
      </Typography>
      <Typography variant="body1" className="mb-4">
        Tell us the colour you want. We can send several similar colours for
        you to choose from, and help you find the colour and finish you
        need.
      </Typography>
      <Typography variant="body1">
        Colour photos are for reference only. As natural stone, colour and
        veining may vary from batch to batch and from the photo or sample
        shown; samples are for general colour reference only and cannot
        guarantee an exact match.
      </Typography>
      <Typography variant="body1" className="mt-6">
        <Link to="/products" className="underline">
          Back to Products
        </Link>{" "}
        ·{" "}
        <Link to="/contact" className="underline">
          Request Quote
        </Link>
      </Typography>
    </Box>
  );
}

export default ProcessingPage;
